import { Factory } from '../../services/Factory';
import { AdvancedSearch } from '../../model/search/advanced/AdvancedSearch';
import { BasicSearch } from '../../model/search/basic/BasicSearch';

namespace app.controllers.batching {

  interface IAddBatchesScope extends angular.IScope {
    batchConfig: any;
    closeModal: Function;
    startBatching: Function;
    saving: boolean;
  }

  export class AddBatchModalController {
    private $scope: IAddBatchesScope;
    private $modalInstance: any;
    private project: any;
    private batchService: app.services.batching.BatchService;
    private notificationService: app.services.INotificationService;

    constructor($scope: IAddBatchesScope, $modalInstance: any, project: any, collections: any[], resources: Array<string>, search: any, columnFilters: any, filter: any, selectAll: boolean, batchService: app.services.batching.BatchService, notificationService: app.services.INotificationService) {
      this.$scope = $scope;
      this.$modalInstance = $modalInstance;
      this.project = project;
      this.batchService = batchService;
      this.notificationService = notificationService;

      this.$scope.batchConfig = new app.model.batching.Batch();
      this.$scope.closeModal = () => {
        this.$modalInstance.close();
      };
      this.$scope.startBatching = () => {
        if(!resources?.length && !selectAll) {
          this.notificationService.addError({
            title: "No Resources Selected For Batching",
            description: `Prefix: ${this.$scope.batchConfig.prefix}`,
            timeout: 5000
          });
        } else {
          this.$scope.batchConfig.projectId = project.id;
          this.$scope.batchConfig.collections = _.pluck(collections, "id");
          this.$scope.batchConfig.filter = filter;
          this.$scope.batchConfig.searchExpression = search instanceof AdvancedSearch && !resources ? search.expression : null;
          this.$scope.batchConfig.query = search instanceof BasicSearch && !resources ? search.expression : null;
          this.$scope.batchConfig.columnFilters = columnFilters?.expression;
          this.$scope.batchConfig.resources = resources;
          this.$scope.saving = true;

          this.batchService.Save(this.batchService.Create(this.$scope.batchConfig)).then(() => {
            this.$scope.saving = false;
            $modalInstance.close();

            this.notificationService.addSuccess({
              title: "Batching started successfully",
              description: `Prefix: ${this.$scope.batchConfig.prefix}`,
              timeout: 5000
            });
          }).catch(() => this.$scope.saving = false);
        }
      };
    }
  }

  frontendApp.controller("AddBatchModalController", ["$scope", "$uibModalInstance", "project", "collection", "resources", "search", "columnFilters", "filter", "selectAll", "BatchService", "NotificationService", Factory.Create(AddBatchModalController)]);
}
